import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { MessageSquareWarning } from 'lucide-react';
import RefundRequestActions from './RefundRequestActions';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

/**
 * O pedido de estorno do comprador no detalhe do pedido: quem pediu, por quê e
 * os botões para responder. Só aparece enquanto espera resposta; depois o status
 * do pedido (estornado) ou o sino contam o que foi decidido.
 *
 * `refundRequest` é o `refund_request` do detalhe (GET /orders/detail/{id}).
 */
export default function RefundRequestCard({ refundRequest, onAnswered }) {
    if (refundRequest?.status !== 'pending') return null;

    return (
        <Card role='region' aria-label='Pedido de estorno esperando resposta'>
            <Header>
                <MessageSquareWarning size={18} aria-hidden='true' />
                <Title>Pedido de estorno esperando sua resposta</Title>
            </Header>

            <Facts>
                {refundRequest.requester_name && (
                    <Fact>Solicitado por <strong>{refundRequest.requester_name}</strong></Fact>
                )}
                {refundRequest.created_at && (
                    <Fact>em {dayjs(refundRequest.created_at).format('DD/MM/YYYY [às] HH:mm')}</Fact>
                )}
            </Facts>

            <Reason>Motivo: <strong>{refundRequest.reason_label}</strong></Reason>
            {refundRequest.details && <Quote>“{refundRequest.details}”</Quote>}

            <RefundRequestActions refundRequest={refundRequest} onAnswered={onAnswered} />
        </Card>
    );
}

const Card = styled.section`
    margin: 16px 0;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #FCD34D;
    background: #FFFBEB;
    color: #92400E;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #92400E;
`;

const Facts = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 8px;
`;

const Fact = styled.span`
    font-size: ${fonts.sizes.small};
    color: ${colors.nightDark};
`;

const Reason = styled.p`
    margin: 8px 0 0;
    font-size: 13px;
    color: ${colors.nightDark};
`;

const Quote = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    font-style: italic;
    color: ${colors.night};
`;
